export default __webpack_public_path__ + "static/media/login-bg-51.64e7a6f1.jpg";